import React from 'react'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material'
import { Circle } from '@mui/icons-material'

function NormalTextList({ items }: { items: Array<string> }) {
    const bulletIcon = <Circle sx={{ fontSize: '12px' }} />

    return (
        <List>
            {items.map((item) => (
                <ListItem key={item}>
                    <ListItemIcon>{bulletIcon}</ListItemIcon>
                    <ListItemText primary={item} />
                </ListItem>
            ))}
        </List>
    )
}

/**
 * A form for confirming the deletion of a convertible.
 */
export function DeleteConvertibleConfirmationDialog({
    open,
    onClose,
    onDelete,
}: {
    open: boolean
    onClose: () => void
    onDelete: () => Promise<void>
}) {
    const handleDelete = () => void onDelete()

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Radera konvertibel</DialogTitle>
            <DialogContent>
                <Typography>
                    När du raderar en konvertibel kommer alla beroenden också att försvinna, inklusive:
                </Typography>
                <NormalTextList items={['Investerare', 'Rådgivare', 'Källor', 'Länkade emissioner']} />
                <Typography>Är du ok med att radera denna konvertibel? Det går inte att ångra raderingen.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='primary'>
                    Avbryt
                </Button>
                <Button onClick={handleDelete} color='primary' autoFocus>
                    Ok, radera
                </Button>
            </DialogActions>
        </Dialog>
    )
}
